<template>
  <div>
    <!-- 列表页面 -->
    <div class="container" v-if="!showEdit">
      <sticky-top>
        <div class="header">
          <div class="title">文章列表</div>
          <div class="header-right" v-auth="'搜索文章'">
            <div class="filter-area">
              <span class="filter-title">显示标题</span>
              <el-switch @change="onFilterDisplay" v-model="filterByDisplay"></el-switch>
            </div>
            <lin-search @query="onQueryChange" ref="searchKeyword" />
          </div>
        </div>
      </sticky-top>
      <!-- 表格 -->
      <lin-table
        ref="table"
        :tableColumn="tableColumn"
        :tableData="tableData"
        :operate="operate"
        @handleOperate="handleOperate"
        @handleEdit="handleEdit"
        @handleDelete="handleDelete"
        @row-click="rowClick"
        v-loading="loading"></lin-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :background="true"
          :page-size="pageCount"
          :current-page="currentPage"
          v-if="refreshPagination"
          layout="prev, pager, next, jumper"
          :total="total_nums">
        </el-pagination>
      </div>
    </div>

    <!-- 编辑页面 -->
    <article-edit v-else @editClose="editClose" :dataID="dataID"></article-edit>

    <!-- 预览页面 -->
    <preview :visiable="showPreview" v-model="showPreview" :info="selectedRow"/>

  </div>
</template>

<script>
import article from '../models/article'
import LinTable from '@/components/base/table/lin-table'
import ArticleEdit from './ArticleEdit'
import Preview from './Preview'
import LinSearch from '@/components/base/search/lin-search'
import ChangeDisplay from './ChangeDisplay'
import TableImage from '../../Common/components/TableImage'

export default {
  components: {
    LinTable,
    ArticleEdit,
    Preview,
    LinSearch,
    ChangeDisplay,
    TableImage,
  },
  data() {
    return {
      tableColumn: [{ prop: 'title', label: '书名' },
        {
          prop: 'image',
          label: '封面',
          style: {width:"80px",height:"80px"},
          component: TableImage,
        },
        { prop: 'summary', label: '简介' },
        { prop: 'view_count', label: '浏览次数' },
        { prop: 'click_count', label: '点击次数' },
        { prop: 'display', label: '显示标题', component: ChangeDisplay },
      ],
      tableData: [],
      operate: [],
      showEdit: false,
      dataID: 1,

      refreshPagination: true, // 页数增加的时候，因为缓存的缘故，需要刷新Pagination组件
      total_nums: 0, // 分组内的总数
      currentPage: 1, // 默认获取第一页的数据
      pageCount: 10, // 每页10条数据
      searchKeyword: '',
      filterByDisplay: false,

      showPreview: false,
      selectedRow: {},
    }
  },
  async created() {
    this.loading = true
    this.getDatas()
    this.operate = [
      { name: '浏览', operate: 'preview', type: 'primary' },
      {
        name: '编辑',
        func: 'handleEdit',
        type: 'primary',
      },
      {
        name: '删除',
        func: 'handleDelete',
        type: 'danger',
        auth: '删除文章',
      }]
    this.loading = false
  },
  methods: {
    onQueryChange(query) {
      // 处理带空格的情况
      this.searchKeyword = query.trim()
      this.getDatas()
    },
    onFilterDisplay(value) {
      this.getDatas()
    },
    async getDatas() {
      try {
        this.loading = true
        const data = await article.getDatas({ count: this.pageCount, page: this.currentPage, q: this.searchKeyword, f_display: this.filterByDisplay })
        this.tableData = data.rows
        this.total_nums = data.count
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.error_code === 10020) {
          this.tableData = []
        }
      }
    },
    handleOperate(val) {
      if (val.operate === 'preview') {
        this.showPreview = true
        this.selectedRow = val.row
        // article.updateCounter(val.row.id, { type: 'view' })
      }
    },
    handleEdit(val) {
      console.log('val', val)
      this.showEdit = true
      this.dataID = val.row.id
    },
    handleDelete(val) {
      this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await article.delectData(val.row.id)
        if (res.error_code === 0) {
          this.getDatas()
          this.$message({
            type: 'success',
            message: `${res.msg}`,
          })
        }
      })
    },
    rowClick() {

    },
    editClose() {
      this.showEdit = false
      this.getDatas()
    },

    // 切换table页
    async handleCurrentChange(val) {
      this.currentPage = val
      this.loading = true
      await this.getDatas()
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    padding: 0 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      height: 59px;
      line-height: 59px;
      color: $parent-title-color;
      font-size: 16px;
      font-weight: 500;
    }

    .filter-area {
      margin:0 5px;
    }

    .filter-title {
      font-size: 12px;
      margin-right: 5px;
    }
  }

  .header-right {
    float: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }
}
</style>
